const getCollectionSchema = (shopifyCollection, products) => {
  if (!shopifyCollection) {
    return null;
  }

  const productItemListElement = [];

  if (products.length) {
    products.forEach((product, index) => {
      productItemListElement[index] = {
        '@type': 'ListItem',
        position: index,
        name: product.title,
      };
    });
  }

  return {
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    name: shopifyCollection.categoryName,
    url: shopifyCollection.handle,
    description: shopifyCollection.categorySeo?.description,
    mainEntityOfPage: {
      '@type': 'CollectionPage',
      '@id': shopifyCollection.handle,
      name: shopifyCollection.categoryName,
    },
    itemListElement: productItemListElement,
  };
};

export default getCollectionSchema;
